import { ButtonType, ButtonWidget, InteractionState } from '@tableau/widgets';
import React from 'react';
import ReactDOM from 'react-dom';


export interface ExplorerDropdownIconButtonProps extends Pick<React.AriaAttributes, 'aria-labelledby'> {
  readonly onClick: (e: React.SyntheticEvent<HTMLDivElement, Event>) => void;
  readonly testId: string;
  readonly renderButtonContent: (showingOrActive: boolean, disabled: boolean) => JSX.Element | string;
  readonly title?: string;
  readonly showingPanel?: boolean;
  readonly height?: string;
  readonly setButtonRef?: (ref: HTMLButtonElement | null) => void;
  readonly buttonStyleOverrides?: React.CSSProperties;
  readonly disabled?: boolean;
  readonly tabIndex?: number;
}

export function ExplorerDropdownIconButton(props: ExplorerDropdownIconButtonProps): JSX.Element {

  return (
    <ButtonWidget
      aria-labelledby={props['aria-labelledby']}
      buttonType={ButtonType.LowEmphasis}
      handleClick={props.onClick}
      testId={props.testId}
      title={props.title}
      style={{ ...props.buttonStyleOverrides }}
      ref={
        React.useCallback(
          ref => props.setButtonRef(ref ? ReactDOM.findDOMNode(ref) as HTMLButtonElement : null),
          // This deps array was noncompliant before we enabled the lint rule. If you’re here, please consider fixing it! See TFS 1257824
          // eslint-disable-next-line react-hooks/exhaustive-deps
          [props.setButtonRef]
        )
      }
      disabled={props.disabled}
      tabIndex={props.tabIndex}
      getContent={(interactionState: InteractionState) => {
        const showingOrActive = props.showingPanel || interactionState.hover || interactionState.active || interactionState.focus;
        return props.renderButtonContent(showingOrActive, props.disabled);
      }}
    />
  );
}
